import React from "react";

export default function GradientButton(props) {
  return (
    <button
      className={`bg-button-bg text-white py-[8px] px-6 font-poppins transition duration-75 ease-linear hover:bg-hover-bg rounded-md text-lg max-lg:text-sm ${props.width}`}
      onClick={props.onClick}
    >
      {props.btnText}
    </button>
  );
}
